import loadable from '@loadable/component';

const ClaimsLoadable = loadable(() => import(/* webpackChunkName: 'claims' */ './Claims'));

const Claims = () => <ClaimsLoadable />;

export default Claims;
